module.exports = __webpack_public_path__ + "static/media/20ECE6.28c8df2c.jpg";